// CommerceItem
// ===================
// Represents a non-promotional item in the cart by sku.
// For example, if a user has 5x of the same item in their cart,
// it is only represented by a single CommerceItem with a `quantity`
// property of `5`.
define(['common/models/base'], function(Base) {
  var CommerceItem = Base.extend({
    defaults: {
    },

    addGiftCert(data, attrs) {
      var model = this;

      attrs || (attrs = {});

      return this.sync('addGiftCert', this, $.extend(attrs, {
        data,
        success(data) {
          model.trigger('addGiftCertSuccess', data);
        },
        error(data) {
          model.trigger('addGiftCertError', data.formExceptions);
        },
      }));
    },

    parse(result) {
      var data = (result.attributes || result);

      if (data.productName) {
        data.productName = $('<div/>').html(data.productName)
          .text();
      }

      return result;
    },

    // Updates the quantity of the given commerce item in the cart on the server.
    setQuantity(data) {
      var commerceItemUrl = document.location.protocol +
                '//' +
                document.location.host +
                '/Store/cart/commerceItem.json.jsp?commerceItemId=' +
                this.id;
      var oldQuantity = this.get('quantity') || 0;
      var self = this;

      // Modify data to conform to formHandler
      data.updateCommerceItemQty = data.quantity;
      data.updateCommerceId = this.id;
      data.updateItemSuccessURL = commerceItemUrl;
      data.updateItemErrorURL = commerceItemUrl;
      delete data.quantity;

      return this.sync('updateQuantity', this, {
        data,
        success() {
          $.publish('commerce_item:update', self, oldQuantity);
        },
      });
    },

    // Removes an item completely from the cart.
    remove() {
      // Modify data to conform to formHandler
      var self = this;

      self.removed = true;
      var data = {
        removalCommerceIds: self.id,
      };

      return this.sync('remove', self, {
        data,
        success() {
          $.publish('commerce_item:remove', self);
        },
      });
    },
  });

  return CommerceItem;
});
